var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-notification-panel-item-group"},[(_vm.group.label)?_c('div',{staticClass:"c-notification-header"},[_vm._v(" "+_vm._s(_vm.$t('notifications.headers.' + _vm.group.label))+" ")]):_vm._e(),_c(_setup.NotificationPanelItems,{attrs:{"items":_vm.group.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }